module.exports = __webpack_public_path__ + "static/media/email_icon.d97b3c8b.svg";